import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let sentThisMinute = 0;
setInterval(() => { sentThisMinute = 0; }, 60000);

const report = (type, message) => {
    const auth = axios.defaults.headers.common.Authorization;
    if (!auth || sentThisMinute >= 10) return;
    sentThisMinute += 1;
    axios.post(`${API}/client-errors`, { type, message: String(message).slice(0, 300), path: window.location.pathname }).catch(() => {});
};

// Errores de JS no capturados y respuestas del servidor que ninguna pantalla mostró.
export const installErrorReporting = () => {
    window.addEventListener('error', (e) => report(e.error?.name || 'Error', e.message));
    window.addEventListener('unhandledrejection', (e) => {
        if (e.reason?.isAxiosError) return;
        report(e.reason?.name || 'UnhandledRejection', e.reason?.message || e.reason);
    });
    axios.interceptors.response.use(undefined, (error) => {
        const url = error.config?.url || '';
        if (url.includes('/client-errors')) return Promise.reject(error);
        if (!error.response) {
            toast.error('Sin conexión con el servidor. Revisa tu internet e inténtalo de nuevo.', { id: 'net-error' });
        } else if (error.response.status >= 500) {
            toast.error('Ocurrió un error en el servidor. Ya quedó registrado para el equipo de AeroOps.', { id: 'server-error' });
        }
        return Promise.reject(error);
    });
};
